import { Component } from '@angular/core'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-bulk-entry-dialog',
  templateUrl: './bulk-entry-dialog.component.html',
})
export class BulkEntryDialogComponent {
  data: string | undefined

  constructor(
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
  ) {}

  submitBulkEntry() {
    this.activeModal.close(this.data)
  }
}
